// Static Reducers

export const REDUCER_NAME_ME = 'me'
